/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'
import { GachaPartsSet } from '../../Gacha/Common/GachaPartsSet'

export const protobufPackage = 'Reality.Reality.Api'

export interface GachaItem {
  itemId: number
  rarity: number
  name: string
  priority: number
  partsSets: GachaPartsSet[]
}

function createBaseGachaItem(): GachaItem {
  return { itemId: 0, rarity: 0, name: '', priority: 0, partsSets: [] }
}

export const GachaItem = {
  encode(
    message: GachaItem,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.itemId !== 0) {
      writer.uint32(8).int64(message.itemId)
    }
    if (message.rarity !== 0) {
      writer.uint32(16).int64(message.rarity)
    }
    if (message.name !== '') {
      writer.uint32(26).string(message.name)
    }
    if (message.priority !== 0) {
      writer.uint32(32).int64(message.priority)
    }
    for (const v of message.partsSets) {
      GachaPartsSet.encode(v!, writer.uint32(42).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaItem {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGachaItem()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.itemId = longToNumber(reader.int64() as Long)
          break
        case 2:
          message.rarity = longToNumber(reader.int64() as Long)
          break
        case 3:
          message.name = reader.string()
          break
        case 4:
          message.priority = longToNumber(reader.int64() as Long)
          break
        case 5:
          message.partsSets.push(GachaPartsSet.decode(reader, reader.uint32()))
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): GachaItem {
    return {
      itemId: isSet(object.itemId) ? Number(object.itemId) : 0,
      rarity: isSet(object.rarity) ? Number(object.rarity) : 0,
      name: isSet(object.name) ? String(object.name) : '',
      priority: isSet(object.priority) ? Number(object.priority) : 0,
      partsSets: Array.isArray(object?.partsSets)
        ? object.partsSets.map((e: any) => GachaPartsSet.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GachaItem): unknown {
    const obj: any = {}
    message.itemId !== undefined && (obj.itemId = Math.round(message.itemId))
    message.rarity !== undefined && (obj.rarity = Math.round(message.rarity))
    message.name !== undefined && (obj.name = message.name)
    message.priority !== undefined &&
      (obj.priority = Math.round(message.priority))
    if (message.partsSets) {
      obj.partsSets = message.partsSets.map((e) =>
        e ? GachaPartsSet.toJSON(e) : undefined
      )
    } else {
      obj.partsSets = []
    }
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<GachaItem>, I>>(
    object: I
  ): GachaItem {
    const message = createBaseGachaItem()
    message.itemId = object.itemId ?? 0
    message.rarity = object.rarity ?? 0
    message.name = object.name ?? ''
    message.priority = object.priority ?? 0
    message.partsSets =
      object.partsSets?.map((e) => GachaPartsSet.fromPartial(e)) || []
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
